import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Coupon, CouponCreate, CouponFilter } from '../data/coupon';

export function createCouponService(client: AxiosInstance) {
  return createCrudService<Coupon, CouponCreate, CouponFilter>(
    client,
    '/sales/Coupon',
    'couponId',
  );
}

export type CouponService = CrudService<Coupon, CouponCreate, CouponFilter>;
